// extracted by mini-css-extract-plugin
export default {"intimidad":"Intimidad_intimidad__2ThoA","top":"Intimidad_top__tcMY5","title":"Intimidad_title__+rJul","subtitle":"Intimidad_subtitle__MHPBi","bottom":"Intimidad_bottom__3OmUe"};